import { getInvoicingPortalURL } from '@/api/settings-api'
import { useAppSelector } from '@/redux/hooks'
import { useQuery } from '@tanstack/react-query'

function getQueryKey(ecommerceId?: string) {
  return ['invoicingPortal', ecommerceId]
}

export function useInvoicingPortalURL() {
  const ecommerceId = useAppSelector((s) => s.generalData.selectedEcommerce)

  function callInvoicingPortalURL() {
    if (!ecommerceId) return
    return getInvoicingPortalURL(ecommerceId)
  }

  const invoicingPortalURLQuery = useQuery({
    queryKey: getQueryKey(ecommerceId),
    queryFn: callInvoicingPortalURL,
    staleTime: 1000 * 60 * 10,
    enabled: !!ecommerceId
  })

  return {
    invoicingPortalURL: invoicingPortalURLQuery.data?.stripe_url
  }
}
